import LoanTypeSummary from "../Loan/LoanTypeSummary";

/**
 * Loan type panel used by the application forms and both calculators.
 * `loanType` may be a loan type row or a select option that carries one.
 */
const LoanTypeDetails = ({ loanType, className = "", variant = "default", durationType }) => {
  if (!loanType || !(loanType.id || loanType.value)) return null;
  return <LoanTypeSummary loanType={loanType} className={className} variant={variant} durationType={durationType} />;
};

export default LoanTypeDetails;
